const ComingSoon = () => {
    return (<div className="w-100">
        <button type="button" className="btn btn-secondary btn-lg btn-block disabled">Coming Soon</button>
    </div>);
}

export default ComingSoon;